import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	micado: {
		alignItems: "center",
		borderRadius: theme?.shape?.borderRadius,
		color: "inherit",
		display: "inline-flex",
		margin: theme?.spacing(0, -1),
		padding: theme?.spacing(1),
		transition: "background 150ms ease",
		"& svg": {
			display: "block",
			margin: theme?.spacing(0, 1.5, 0, 0)
		},
		"&:hover": {
			background: "rgba(255, 255, 255, 0.05)"
		}
	}
}));

export default styles;
